import { KeyValue } from "@/main/models/common";
import { WarehouseTypes, WarehouseActionTypes } from "./warehouseTypes";
import { WarehouseFilterRequest } from "@/main/models/request";

export function getWarehouse(request: WarehouseFilterRequest): WarehouseActionTypes {
	return {
		type: WarehouseTypes.GET_WAREHOUSE,
		payload: {
			request,
		},
	};
}

export function saveWarehouse(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): WarehouseActionTypes {
	return {
		type: WarehouseTypes.SAVE_WAREHOUSE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerWarehouse(): WarehouseActionTypes {
	return {
		type: WarehouseTypes.RESET_REDUCER_WAREHOUSE,
	};
}
